import { FiPlus } from "react-icons/fi";
import ToggleSwitch from "../ToggleSwitch";
import TimePeriodInput from "./TimePeriodInput";
import { useTranslation } from "react-i18next";
// import { DaysOfWeek, DaysOfWeekAr } from "@/types/enums";

type DayBarProps = {
  dayData: {
    day: number;
    isOpeningDay: boolean;
    timePeriods: { start: string; end: string }[];
  };
  onToggle: (day: number) => void;
  onTimeChange: (
    day: number,
    index: number,
    type: "start" | "end",
    value: string,
  ) => void;
  handleAddTimePeriod: (day: number) => void;
  handleRemoveTimePeriod: (dayIndex: number, periodIndex: number) => void;
  dayIndex: number;
};

function DayBar({
  dayData,
  onToggle,
  onTimeChange,
  handleAddTimePeriod,
  handleRemoveTimePeriod,
  dayIndex,
}: DayBarProps) {
  const { t } = useTranslation();
  const { day, isOpeningDay, timePeriods } = dayData;
  const DayKeyMap = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
  ];
  
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2 sm:flex-nowrap">
        {/* Day and Toggle */}
        <div className="flex h-full w-fit items-center gap-2">
          <ToggleSwitch
            onChange={() => onToggle(day)}
            size="small"
            checked={isOpeningDay}
          />
          <h5 className="capitalize">{t(`dayBar.${DayKeyMap[day]}`)}</h5>
        </div>

        <div className="flex flex-col gap-2">
          {/* Time Periods */}
          <div className="flex h-full w-fit items-center justify-end gap-2">
            <TimePeriodInput
              dayIndex={dayIndex}
              isParent={true}
              index={0}
              timePeriod={timePeriods[0]}
              onTimeChange={(idx, type, value) =>
                onTimeChange(day, idx, type, value)
              }
              isDisabled={!isOpeningDay}
            />

            {/* Add button */}
            <button
              type="button"
              disabled={!isOpeningDay}
              className="flex aspect-square md:h-8 h-6 cursor-pointer flex-col items-center justify-center rounded-md border-l bg-sky-300 text-sky-900 duration-300 hover:bg-sky-400 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
              onClick={() => handleAddTimePeriod(dayIndex)}
            >
              <FiPlus />
            </button>
          </div>
          {/* New Time Periods */}
          {isOpeningDay && (
            <div className="flex w-full flex-col gap-4">
              {timePeriods.slice(1).map((period, index) => {
                return (
                  <TimePeriodInput
                    isParent={false}
                    dayIndex={dayIndex}
                    key={index + 1}
                    index={index + 1}
                    timePeriod={period}
                    onTimeChange={(idx, type, value) =>
                      onTimeChange(day, idx, type, value)
                    }
                    onRemove={handleRemoveTimePeriod}
                    isDisabled={!isOpeningDay}
                  />
                );
              }, 1)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DayBar;
